import React, { useEffect, useState } from "react";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";
import { API } from "../../../../../../services/api";
import { styled } from "styled-components";

const PDFViewer = ({ meetingId, meetingInfo }) => {
  const [pdfHtmtl, setPdfHtml] = useState();
  const [lngType, setLngType] = useState("uz-en");

  useEffect(() => {
    const fetchPdfHtml = async () => {
      try {
      console.log(lngType)
      console.log(lngType=="uz-ru"?"ru":lngType=="en-ru"?"en":"uz")
        const response = meetingInfo.meetingType=="OFFLINE"?await API.getAgendaHtml({
                                                                      meetingId: meetingId,
                                                                      lang: lngType=="uz-ru"?"ru":lngType=="en-ru"?"en":"uz",
                                                                    }):await API.getProtocolHtml({
          meetingId: meetingId,
          lang: lngType,
        });
        setPdfHtml(response.data);
      } catch (error) {
        console.error("Error fetching PDF HTML:", error);
      }
    };
    fetchPdfHtml();
  }, [lngType, meetingId]);

  if (pdfHtmtl) {
    document.getElementById("pdf").innerHTML = pdfHtmtl;
  }
  const body=<><div className="lang-cards">
                                                      <button
                                                        className={lngType === "uz-en" ? "active" : ""}
                                                        onClick={() => setLngType("uz-en")}
                                                      >
                                                      { meetingInfo.meetingType=="OFFLINE"?"UZ":"UZ-EN"}
                                                      </button>
                                                      <button
                                                        className={lngType === "en-ru" ? "active" : ""}
                                                        onClick={() => setLngType("en-ru")}
                                                      >

                                                          { meetingInfo.meetingType=="OFFLINE"?"EN":"RU-EN"}
                                                      </button>
                                                      <button
                                                        className={lngType === "uz-ru" ? "active" : ""}
                                                        onClick={() => setLngType("uz-ru")}
                                                      >

                                                          { meetingInfo.meetingType=="OFFLINE"?"RU":"UZ-RU"}
                                                      </button>
                                                    </div>
                                                    <div id="pdf" className="pdf-card"></div></>;
  return (
    <>
      {meetingInfo.meetingType!="OFFLINE"?<ProtocolPdfOffline>
             {body}
           </ProtocolPdfOffline>:<ProtocolPdfOffline>
                                {body}
                              </ProtocolPdfOffline>}
    </>
  );
};

export default PDFViewer;
const ProtocolPdf =styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 20px;
    gap: 20px;

    .lang-cards {
      display: flex;
      gap: 20px;

      button {
        padding: 8px 20px;
        border: 2px solid #ddf8f0;
        font-weight: bold;
        border-radius: 7px;
        background: transparent;
        cursor: pointer;
      }

      .active {
        border-color: #208667;
      }
    }

    .active {
      border-color: #208667;
    }

  `;
   const ProtocolPdfOffline = styled.div`
        display: flex;

        flex-direction: column;
        align-items: center;
        .pdf-card{
        text-align: start!important;
          list-style: inherit!important;
        }
        margin-top: 20px;
        gap: 20px;

        .lang-cards {
          display: flex;
          gap: 20px;

          button {
            padding: 8px 20px;
            border: 2px solid #ddf8f0;
            font-weight: bold;
            border-radius: 7px;
            background: transparent;
            cursor: pointer;
          }

          .active {
            border-color: #208667;
          }
        }

        .active {
          border-color: #208667;
        }
        ul {
            list-style: inherit!important;
        }
      `;

